import { httpClient } from '../httpClient';

export const dpaApi = {
  listDPAs: (params = {}) =>
    httpClient.get('/dpa/', { params }),

  createDPA: (data) =>
    httpClient.post('/dpa/', data),

  getDPA: (id) =>
    httpClient.get(`/dpa/${id}`),

  updateDPA: (id, data) =>
    httpClient.patch(`/dpa/${id}`, data),

  deleteDPA: (id) =>
    httpClient.delete(`/dpa/${id}`),

  linkToROPA: (ropaId, dpaId) =>
    httpClient.post(`/dpa/ropa/${ropaId}/link`, { dpaId }),

  unlinkFromROPA: (ropaId, dpaId) =>
    httpClient.post(`/dpa/ropa/${ropaId}/unlink`, { dpaId }),

  listROPADPAs: (ropaId) =>
    httpClient.get(`/dpa/ropa/${ropaId}/list`),
};
